<template>
  <v-app>
    <v-container grid-list-xl fluid class="pa-0" wrap>
      <v-toolbar class="elevation-1">
        <h4>Emergency - {{ (userType || "").toUpperCase() }}</h4>
        <v-spacer></v-spacer>
        <v-btn-toggle
          fluid
          v-model="userType"
          class="d-flex elevation-0"
          flat
          v-if="!$route.params.type"
        >
          <v-btn
            v-for="type in userTypes"
            :key="type"
            :value="type.toLowerCase()"
            color="#E0E0E0"
            class="elevation-0"
            >{{ type }}</v-btn
          >
        </v-btn-toggle>
        <v-btn
          v-if="!$route.params.type"
          color="clear"
          icon
          small
          @click="printContent"
        >
          <v-icon>print</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <v-layout row wrap class="pl-4 pr-4 pt-3"> -->
      <v-layout
        row
        wrap
        :class="$route.params.type ? 'ma-0 pa-0' : 'pl-4 pr-4 pt-3'"
      >
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <!-- <v-card>
                <v-radio-group v-model="radios" :mandatory="false">
                  <v-radio label="Radio 1" value="radio-1"></v-radio>
                  <v-radio label="Radio 2" value="radio-2"></v-radio>
                </v-radio-group>
              </v-card>-->
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Search..."
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <div class="flex-grow-1"></div>
              <v-btn-toggle
                fluid
                v-model="mode"
                class="d-flex elevation-0"
                flat
              >
                <v-btn
                  v-for="item in ['IN', 'OUT']"
                  :key="item"
                  :value="item.toLowerCase()"
                  color="#E0E0E0"
                  class="elevation-0"
                  >{{ item }}</v-btn
                >
              </v-btn-toggle>
              <v-btn-toggle
                fluid
                v-model="userType"
                class="d-flex elevation-0 ml-3"
                flat
                v-if="$route.params.type"
              >
                <v-btn
                  v-for="type in userTypes"
                  :key="type"
                  :value="type.toLowerCase()"
                  color="#E0E0E0"
                  class="elevation-0"
                  >{{ type }}</v-btn
                >
              </v-btn-toggle>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0 elevation-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                class="elevation-0"
                item-key="name"
                :hide-actions="$route.params.type === 'all'"
              >
                <template slot="items" slot-scope="props">
                  <td v-if="userType && userType === 'all'">
                    <v-chip>{{ props.item.holder_type.toUpperCase() }}</v-chip>
                  </td>
                  <td>
                    <v-chip>{{ attendanceMode(props.item) }}</v-chip>
                  </td>
                  <td>
                    {{
                      [
                        props.item.first_name || "",
                        props.item.last_name || ""
                      ].join(" ")
                    }}
                  </td>
                  <!--
                  <td align="center">
                    {{ props.item.sign_in_date || props.item.sign_out_date }}
                    {{ props.item.sign_in_time || props.item.sign_out_time }}
                  </td>-->
                  <td align="center">
                    {{ props.item.sign_in_time || props.item.sign_out_time }}
                  </td>
                  <td v-if="userType != 'staff' && userType != 'all'">
                    {{
                      props.item.sign_in_reason || props.item.sign_out_reason
                    }}
                  </td>
                  <td align="center" v-if="hasWWCCStatus">
                    <v-chip :color="wwccStatusColor(props.item.wwcc_card)">{{
                      wwccStatus(props.item.wwcc_card)
                    }}</v-chip>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
import Domain from "@/mixins/domain";
import Util from "@/util";
let headers = [
  {
    text: "Attendance Type",
    value: "sign_in_date"
  },
  {
    text: "Name",
    value: "first_name"
  },
  {
    text: "Time",
    value: "sign_in_time",
    align: "center"
  }
];
export default {
  mixins: [APIAttendance, Domain],
  data() {
    return {
      search: "",
      radios: "",
      userType: "all",
      mode: "",
      userTypes: Util.enabledUserTypes(),
      backup: [],
      complex: {
        selected: [],
        headers: headers,
        items: []
      }
    };
  },
  computed: {
    hasWWCCStatus: function() {
      let type = (this.userType || "").toLowerCase();
      return type === "visitor" || type === "contractor";
    }
  },
  watch: {
    userType: {
      handler: function() {
        this.changeType();
      }
    },
    mode: {
      handler: function() {
        this.processList();
      }
    }
  },
  created() {
    this.userType = this.$route.params.type || this.userType;
    this.changeType();
  },
  methods: {
    printContent: function() {
      if (this.complex.items.length === 0) {
        return;
      }

      localStorage.printItems = JSON.stringify(this.complex.items);
      localStorage.printContactMode = this.userType;

      // create print header details
      let printHeaderData = {
        section: {
          top: {
            title: "",
            subtitle: ""
          },
          middle: {
            title: "",
            subtitle: ""
          },
          bottom: {
            subtitle: []
          }
        }
      };

      let company = JSON.parse(localStorage.active_user);

      // top section informations
      printHeaderData.section.top = {
        title: "",
        subtitle: ""
      };

      printHeaderData.section.top.title =
        company.company_name || company.company.name;
      printHeaderData.section.top.subtitle = company.email;

      // middle section informations
      printHeaderData.section.middle = {
        title: "",
        subtitle: ""
      };

      let type = this.userType + "s";
      if (this.userType === "staff") {
        type = "Staff";
      }
      printHeaderData.section.middle.title =
        "Emergency Report - " + type.charAt(0).toUpperCase() + type.slice(1);
      printHeaderData.section.middle.subtitle =
        "Signed In details on " + new Date().toISOString().split("T")[0];

      if (this.userType === "all") {
        printHeaderData.section.middle.title = "Emergency Report";
      }

      // middle section informations
      printHeaderData.section.bottom.subtitle = [];
      printHeaderData.section.bottom.subtitle.push(this.reportGenerateStamp());
      printHeaderData.section.bottom.subtitle.push(
        "Report generated by: edPass"
      );

      localStorage.printHeader = JSON.stringify(printHeaderData);

      let routeData = this.$router.resolve({
        name: "EdpassPrint",
        query: { type: "emergency", mode: this.userType },
        props: true
      });
      window.open(routeData.href, "_blank");
    },
    reportGenerateStamp: function() {
      return (
        "Report generated on: " +
        new Date().toLocaleDateString() +
        " at " +
        new Date().toLocaleTimeString()
      );
    },
    attendanceMode: function(item) {
      let type = item.sign_in_date ? "Sign In" : "Sign Out";
      if (this.userType === "Student") {
        type = item.sign_in_date ? "Late Arrival" : "Early Departure";
      }
      return type;
    },
    changeType: async function() {
      let wwccOb = {
        text: "wwcc card",
        value: "wwcc_card",
        align: "center"
      };
      let userType = {
        text: "User Type",
        value: "holder_type"
      };
      let reasonOb = {
        text: " Reason"
      };
      this.complex.headers = headers;

      if (this.userType === "all") {
        this.complex.headers = await [userType].concat(this.complex.headers);
        await this.handleGetAll();
        return;
      }

      if (["student", "visitor", "contractor"].includes(this.userType)) {
        this.complex.headers = await this.complex.headers.concat([reasonOb]);
      }
      if (this.hasWWCCStatus) {
        this.complex.headers = await this.complex.headers.concat([wwccOb]);
      }
      await this.handleGet();
    },
    wwccStatusColor: function(type) {
      let dic = {};
      dic[0] = "#f8343b";
      dic[1] = "#d88f92";
      dic[2] = "#a7e198";
      dic[3] = "#a7e198";
      return dic[type];
    },
    wwccStatus: function(type) {
      let dic = {};
      dic[0] = "No";
      dic[1] = "Yes, not with me";
      dic[2] = "Yes";
      dic[3] = "Yes";
      return dic[type];
    },
    handleGetAll: async function() {
      this.complex.items = [];
      if (!this.userType) {
        return;
      }
      try {
        let students = await this.emergencyList("student");
        let staff = await this.emergencyList("staff");
        let visitors = await this.emergencyList("visitor");
        let constractors = await this.emergencyList("contractor");

        let list = []
          .concat(students)
          .concat(staff)
          .concat(visitors)
          .concat(constractors);
        this.complex.items = list;
        this.backup = list;
        this.processList();
      } catch (error) {
        this.$toast.error("Failed to fetch records!", "Error", {
          position: "topCenter"
        });
      }
    },
    handleGet: async function() {
      this.complex.items = [];
      if (!this.userType) {
        return;
      }
      try {
        let list = await this.emergencyList(
          (this.userType || "").toLowerCase()
        );
        this.complex.items = list;
        this.backup = list;
        this.processList();
      } catch (error) {
        this.$toast.error("Failed to fetch records!", "Error", {
          position: "topCenter"
        });
      }
    },
    processList() {
      if (!this.mode) {
        this.complex.items = this.backup;
        return;
      }
      this.complex.items = this.backup.filter(obj => {
        return this.mode === "in" ? obj.sign_in_date : obj.sign_out_date;
      });
    },
    handleMoreInfo(row) {
      this.$router.push({
        name: "signedOut View",
        params: { object: row, id: row._id }
      });
    }
  }
};
</script>
